import React from 'react'
import { getRelativeServiceBasePath } from '../../../global/environments/path'

function SubscribedLoadingModal() {
  return (
    <div className="u-textCenter u-marginVert10gu js-loading-modal">
      <p>We&apos;re saving your preferences</p>
      <img
        src={
          getRelativeServiceBasePath() +
          `/webfiles/latest/assets/cti/images/cti-page-loader-icon.gif`
        }
        alt="Loading..."
      />
    </div>
  )
}

export default SubscribedLoadingModal
